/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { run_ai_site_selection } from "../../App/actions/site_selections";
import { set_value_insight } from "../../App/actions/insight_v2";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const SS_AI = ({
  auth,
  insight_reducer,
  run_ai_site_selection,
  set_value_insight,
}) => {
  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  const { prompt_ss } = insight_reducer;

  const on_change = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    set_value_insight({
      key: name,
      value: value,
    });
  };

  //content

  return (
    <main>
      <p className="text_medium sub_color margin_bottom">
        {dict?.["Type your business needs/location"]?.[language]}
      </p>
      <textarea
        placeholder={dict?.["Type here..."]?.[language]}
        rows={5}
        className="margin_bottom"
        name="prompt_ss"
        value={prompt_ss}
        onChange={(event) => on_change(event)}
      />
      <section className="text_center">
        <button
          className="button_big button_white outline_black"
          onClick={() => run_ai_site_selection()}
        >
          {dict?.["Create a Formula"]?.[language]}
        </button>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  insight_reducer: state.insight_reducer,
});

export default connect(mapStateToProps, {
  run_ai_site_selection,
  set_value_insight,
})(SS_AI);
